/**
 * Nota da questão só quando acrescenta algo: no conteúdo importado a nota costuma ser
 * uma cópia da explicação, e mostrar as duas repetia o mesmo texto.
 */
export function extraNote(question) {
  const note = question?.questionNote?.trim();
  if (!note) return null;
  const explanation = question.explanation?.trim() || '';
  return explanation.includes(note) ? null : note;
}
